import { Box, Flex, Link, Text } from 'pcln-design-system'
import { LinkFlex } from './SEOLinks.styled'

type Link = {
  href: string
  text: string
}

export default function SEOLinks({ caption, links }: { caption: string; links: Link[] }) {
  return (
    <Box>
      <Text fontSize={3} fontWeight='bold' mb={3} textAlign='left'>
        {caption}
      </Text>
      <Flex flexWrap='wrap'>
        {links.map((link, index) => (
          <LinkFlex key={`SEO-Flex-${index + 1}`}>
            {link.href?.length > 0 && link.text?.length > 0 ? (
              <Link href={link.href}>
                <Text fontSize={1} mb={2}>
                  {link.text}
                </Text>
              </Link>
            ) : null}
          </LinkFlex>
        ))}
      </Flex>
    </Box>
  )
}
